import { userHasRole } from "./roleRouting";

export function canManageSensitiveMemberActions(isSuperAdmin, targetUser) {
    return isSuperAdmin || !userHasRole(targetUser, ["super_admin"]);
}
